<template>
    <div class="welcome__main">
        <div class="welcome__title">
            {{ title }} 
        </div>
        <div class="welcome__subtitle">
            {{ subtitle }} 
        </div>
        <div class="welcome__info">
            {{ infoFirst }} 
        </div>
        <div class="welcome__info">
            {{ infoSecond }} 
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { Strings } from "@/locales/types/enums/strings";
    import { useI18n } from "vue-i18n";

    const { t } = useI18n();
    const title: string = t(Strings.LOGIN_WELCOME_FIRST_TITLE).toString();
    const subtitle: string = t(Strings.LOGIN_WELCOME_FIRST_SUBTITLE).toString();
    const infoFirst: string = t(Strings.LOGIN_WELCOME_FIRST_INFO_FIRST).toString();
    const infoSecond: string = t(Strings.LOGIN_WELCOME_FIRST_INFO_SECOND).toString();
</script>